import { render } from "./AddNewUser.vue?vue&type=template&id=8a1e7b36&scoped=true"
import script from "./AddNewUser.vue?vue&type=script&lang=js"
export * from "./AddNewUser.vue?vue&type=script&lang=js"

import "./AddNewUser.vue?vue&type=style&index=0&id=8a1e7b36&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1e7b36"]])

export default __exports__